var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactOlextLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React-Olext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_23",
    transform: "matrix(-0.476735 0.879047 -0.950356 -0.311166 1359.95 23.6136)",
    y: -1761.3143,
    x: 699.2251,
    ry: 89.57369,
    height: 396.80566,
    width: 394.26315,
    stroke: "#000000",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("metadata", {
    id: "svg_22"
  }, "image/svg+xml"), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    fill: "#61DAFB",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m67.59115,30.00663c0,-4.30705 -5.6413,-8.38881 -14.29038,-10.92003c1.99594,-8.42857 1.10886,-15.13431 -2.79986,-17.28121c-0.90095,-0.50359 -1.95436,-0.74214 -3.1048,-0.74214l0,2.9553c0.63759,0 1.15044,0.11927 1.58012,0.34456c1.88505,1.03369 2.70284,4.96967 2.06524,10.03211c-0.15247,1.24573 -0.40196,2.55773 -0.7069,3.89622c-2.7167,-0.63612 -5.68289,-1.12646 -8.80154,-1.44452c-1.87119,-2.45171 -3.81169,-4.67812 -5.76605,-6.62623c4.51859,-4.0155 8.75996,-6.21541 11.64298,-6.21541l0,-2.9553c-3.81169,0 -8.80154,2.59748 -13.84684,7.10332c-5.04529,-4.47933 -10.03514,-7.05031 -13.84684,-7.05031l0,2.9553c2.86916,0 7.1244,2.18666 11.64298,6.17565c-1.9405,1.94811 -3.88099,4.16127 -5.72447,6.61298c-3.13252,0.31806 -6.09871,0.8084 -8.8154,1.45777c-0.3188,-1.32525 -0.55443,-2.61074 -0.72076,-3.84321c-0.65145,-5.06244 0.15247,-8.99842 2.02366,-10.04537c0.41582,-0.23854 0.95639,-0.34456 1.59398,-0.34456l0,-2.9553c-1.1643,0 -2.21771,0.23854 -3.13252,0.74214c-3.89486,2.1469 -4.76808,8.83939 -2.75828,17.24145c-8.62135,2.54447 -14.23493,6.61298 -14.23493,10.90678c0,4.30705 5.6413,8.38881 14.29038,10.92003c-1.99594,8.42857 -1.10886,15.13431 2.79986,17.28121c0.90095,0.50359 1.95436,0.74214 3.11866,0.74214c3.81169,0 8.80154,-2.59748 13.84684,-7.10332c5.04529,4.47933 10.03514,7.05031 13.84684,7.05031c1.1643,0 2.21771,-0.23854 3.13252,-0.74214c3.89486,-2.1469 4.76808,-8.83939 2.75828,-17.24145c8.59363,-2.53122 14.20721,-6.61298 14.20721,-10.90678zm-18.04663,-8.83939c-0.51285,1.70957 -1.15044,3.47215 -1.87119,5.23472c-0.56829,-1.0602 -1.1643,-2.12039 -1.81575,-3.18059c-0.63759,-1.0602 -1.31677,-2.09389 -1.99594,-3.10108c1.96822,0.2783 3.86713,0.62287 5.68289,1.04694zm-6.3482,14.11387c-1.08113,1.78908 -2.18999,3.4854 -3.34043,5.06244c-2.06524,0.17228 -4.15821,0.26505 -6.26503,0.26505c-2.09297,0 -4.18593,-0.09277 -6.23731,-0.2518c-1.15044,-1.57704 -2.27315,-3.26011 -3.35429,-5.03594c-1.05341,-1.73607 -2.0098,-3.49865 -2.88302,-5.27448c0.85936,-1.77583 1.82961,-3.55166 2.86916,-5.28773c1.08113,-1.78908 2.18999,-3.4854 3.34043,-5.06244c2.06524,-0.17228 4.15821,-0.26505 6.26503,-0.26505c2.09297,0 4.18593,0.09277 6.23731,0.2518c1.15044,1.57704 2.27315,3.26011 3.35429,5.03594c1.05341,1.73607 2.0098,3.49865 2.88302,5.27448c-0.87322,1.77583 -1.82961,3.55166 -2.86916,5.28773zm4.477,-1.72282c0.74848,1.77583 1.38607,3.55166 1.91278,5.27448c-1.81575,0.42408 -3.72853,0.7819 -5.71061,1.0602c0.67917,-1.02044 1.35835,-2.06738 1.99594,-3.14083c0.63759,-1.0602 1.2336,-2.13365 1.80189,-3.19384zm-14.05475,14.14038c-1.28904,-1.27224 -2.57809,-2.69025 -3.85327,-4.24079c1.24746,0.05301 2.52265,0.09277 3.81169,0.09277c1.30291,0 2.59195,-0.0265 3.85327,-0.09277c-1.24746,1.55054 -2.53651,2.96855 -3.81169,4.24079zm-10.31236,-7.8057c-1.96822,-0.2783 -3.86713,-0.62287 -5.68289,-1.04694c0.51285,-1.70957 1.15044,-3.47215 1.87119,-5.23472c0.56829,1.0602 1.1643,2.12039 1.81575,3.18059c0.65145,1.0602 1.31677,2.09389 1.99594,3.10108zm10.24305,-27.57838c1.28904,1.27224 2.57809,2.69025 3.85327,4.24079c-1.24746,-0.05301 -2.52265,-0.09277 -3.81169,-0.09277c-1.30291,0 -2.59195,0.0265 -3.85327,0.09277c1.24746,-1.55054 2.53651,-2.96855 3.81169,-4.24079zm-10.25692,7.8057c-0.67917,1.02044 -1.35835,2.06738 -1.99594,3.14083c-0.63759,1.0602 -1.2336,2.12039 -1.80189,3.18059c-0.74848,-1.77583 -1.38607,-3.55166 -1.91278,-5.27448c1.81575,-0.41083 3.72853,-0.76864 5.71061,-1.04694zm-12.54393,16.59208c-4.90669,-2.00112 -8.08079,-4.62511 -8.08079,-6.70575c0,-2.08064 3.1741,-4.71788 8.08079,-6.70575c1.19202,-0.49034 2.49493,-0.92767 3.83941,-1.3385c0.79006,2.59748 1.82961,5.30099 3.11866,8.07075c-1.27518,2.75651 -2.30088,5.44676 -3.07707,8.03099c-1.37221,-0.41083 -2.67511,-0.86141 -3.88099,-1.35175zm7.45705,18.93777c-1.88505,-1.03369 -2.70284,-4.96967 -2.06524,-10.03211c0.15247,-1.24573 0.40196,-2.55773 0.7069,-3.89622c2.7167,0.63612 5.68289,1.12646 8.80154,1.44452c1.87119,2.45171 3.81169,4.67812 5.76605,6.62623c-4.51859,4.0155 -8.75996,6.21541 -11.64298,6.21541c-0.62373,-0.01325 -1.15044,-0.13252 -1.56626,-0.35782zm32.87757,-10.09838c0.65145,5.06244 -0.15247,8.99842 -2.02366,10.04537c-0.41582,0.23854 -0.95639,0.34456 -1.59398,0.34456c-2.86916,0 -7.1244,-2.18666 -11.64298,-6.17565c1.9405,-1.94811 3.88099,-4.16127 5.72447,-6.61298c3.13252,-0.31806 6.09871,-0.8084 8.8154,-1.45777c0.3188,1.3385 0.56829,2.62399 0.72076,3.85647zm5.33637,-8.83939c-1.19202,0.49034 -2.49493,0.92767 -3.83941,1.3385c-0.79006,-2.59748 -1.82961,-5.30099 -3.11866,-8.07075c1.27518,-2.75651 2.30088,-5.44676 3.07707,-8.03099c1.37221,0.41083 2.67511,0.86141 3.89486,1.35175c4.90669,2.00112 8.08079,4.62511 8.08079,6.70575c-0.01386,2.08064 -3.18796,4.71788 -8.09465,6.70575zm-36.71698,-35.60937z",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    cx: 33.577,
    cy: 30.00663,
    r: 4.84973,
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m47.38226,1.06325z",
    id: "svg_4"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_25"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_16",
    transform: "matrix(0.514439 0 0 0.412744 221.476 124.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    width: 71.05851,
    height: 71.51675,
    ry: 16.14397,
    x: -86.26447,
    y: -425.17996,
    transform: "matrix(0.76602 -0.642816 0.769901 0.638164 0 0)",
    id: "svg_21",
    strokeWidth: 0.14797,
    fillRule: "nonzero",
    fill: "#005964"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    width: 71.05851,
    height: 71.51675,
    ry: 16.14397,
    x: -80.06049,
    y: -431.35269,
    transform: "matrix(0.76602 -0.642816 0.769901 0.638164 0 0)",
    id: "svg_20",
    strokeWidth: 0.14797,
    fillRule: "nonzero",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    width: 71.05851,
    height: 71.51675,
    ry: 16.14397,
    x: -73.19477,
    y: -438.18381,
    transform: "matrix(0.76602 -0.642816 0.769901 0.638164 0 0)",
    id: "svg_19",
    strokeWidth: 0.14797,
    fillRule: "nonzero",
    fill: "#53c5d5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m-378.39225,-218.27346c20.82447,-26.32705 56.71741,-35.41662 87.56242,-22.17441l0,16.19661l-47.21616,39.10767l-40.34625,-33.12987l-0.00001,0z",
    clipPath: "url(#svg_18)",
    id: "svg_17",
    fillRule: "nonzero",
    fill: "#35bcce"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactOlextLogo);
export default __webpack_public_path__ + "static/media/react-olext_logo.dc1c73a575c5172f054e1ca03d4acda1.svg";
export { ForwardRef as ReactComponent };